import { UniqueUserId } from '@xylabs/pixel'
import * as queryString from 'query-string'

const customQueryFieldsIds = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_campaignid',
  'utm_adsetid',
  'utm_adid',
  'utm_content',
  'utm_term',
  'advertiser_id',
  'affiliate_id',
  'aff_id',
  'aff_sub',
  'aff_sub2',
  'aff_sub3',
  'aff_sub4',
  'aff_sub5',
  'aff_click_id',
  'camp_id',
  'contract_id',
  'country_name',
  'ddcref',
  'device_type',
  'gclid',
  'gclsrc',
  'lpid',
  'offer_id',
  'oid',
  'req_id',
  'sub_id',
  'tune_transaction_id',
  'fbc',
  'fbp',
]

const requireTuneTransactionId = (redirect: string) => {
  const parsed = queryString.parse(document.location.search)
  if (!parsed['tune_transaction_id'] && sessionStorage.getItem('tune_id_checked') !== 'true') {
    sessionStorage.setItem('tune_id_checked', 'true')
    window.location.href = redirect
  }
}

const getStoredQueryStringValue = (key: string) => {
  return sessionStorage.getItem(`xy_${key}`)
}

const storeQueryParams = () => {
  const parsed = queryString.parse(document.location.search)
  for (const field of customQueryFieldsIds) {
    const value = parsed[field]
    if (value) {
      sessionStorage.setItem(`xy_${field}`, encodeURIComponent(value.toString()))
    }
  }
}

const restoreQueryString = () => {
  const parsed = queryString.parse(document.location.search)
  let dirty = false
  const queryList: string[] = []
  for (const field of customQueryFieldsIds) {
    const fieldValue = parsed[field] ? (parsed[field] as string) : undefined
    const decodedFieldValue = fieldValue ? decodeURIComponent(fieldValue) : undefined
    const value = sessionStorage.getItem(`xy_${field}`)
    const decodedValue = value ? decodeURIComponent(value) : undefined
    if (decodedValue) {
      if (decodedFieldValue !== decodedValue) {
        dirty = true
      }
      queryList.push(`${field}=${encodeURIComponent(decodedValue)}`)
    }
  }
  if (dirty) {
    window.location.href = `${window.location.pathname}?${queryList.join('&')}`
  }
}

const customQueryFields = () => {
  const result: Record<string, string> = {}
  for (const field of customQueryFieldsIds) {
    const value = sessionStorage.getItem(`xy_${field}`)
    if (value) {
      result[field] = encodeURIComponent(value)
    }
  }
  if (window.location.hostname.endsWith('gocoinapp.com')) {
    result.shipStationStoreId = '214167'
  }
  const uniqueId = new UniqueUserId()
  result.coin_uid = uniqueId.id
  return result
}

const checkGoCoinApp = (tuneRedirectUrl = 'https://website.go2cloud.org/aff_c?offer_id=2&aff_id=1001') => {
  if (window.location.hostname.endsWith('gocoinapp.com')) {
    storeQueryParams()
    restoreQueryString()
    setTimeout(() => {
      requireTuneTransactionId(tuneRedirectUrl)
    }, 0)
  }
}

export { checkGoCoinApp, customQueryFields, getStoredQueryStringValue }
